export const dispatchMethods = [
  { value: 1, label: 'CRM' },
  { value: 2, label: 'Hotcarloads' },
  { value: 3, label: 'Super Dispatch' },
  { value: 4, label: 'Central Dispatch' },
];

export default {
  data() {
    return {
      dispatchMethods,
    };
  },
  methods: {
    dispatchMethodLabel(value) {
      return dispatchMethods.find(pt => pt.value == value).label;
    },
  },
};
